module.exports = __webpack_public_path__ + "media/images/team/freddy-90de2f168b8d287ab0cc22f4f927a994.jpg";